<template>
  <body id="apps" class="fixed-header">
    <div
      class="d-flex justify-content-center full-height full-width align-items-center"
    >
      <div class="error-container text-center">
        <h1 class="error-number">Oops!</h1>
        <h2 class="semi-bold">Error 404: Halaman tidak ditemukan.</h2>
        <div class="error-container-innner text-center">
          <button @click="toDashboard" class="btn btn-primary">
            KE DASHBOARD
          </button>
        </div>
      </div>
    </div>
    <div
      class="pull-bottom sm-pull-bottom full-width d-flex align-items-center justify-content-center"
    >
      <div class="error-container">
        <div class="error-container-innner">
          <div
            class="p-b-30 sm-m-t-20 sm-p-r-15 sm-p-b-20 clearfix d-flex-md-up row no-margin"
          >
            <div
              class="col-md-3 no-padding d-flex align-items-center justify-content-center"
            >
              <!-- <img
                alt=""
                data-src="logo.png"
                data-src-retina="logo.png"
                height="60"
                src="logo.png"
                v-if="is_white_label == 0"
              /> -->
            </div>
            <div
              class="col-md-9 no-padding d-flex align-items-center justify-content-center"
            >
              <p class="small no-margin flex-1">
                Online Media Monitoring. Sistem monitoring sosial media untuk
                menunjang analisis Anda.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: "Login",
  title: "Halaman Tidak Ditemukan! | Sibernetik",
  data() {
    return {
      is_white_label: parseInt(process.env.VUE_APP_WHITELABEL),
    };
  },
  methods: {
    toDashboard: function () {
      let role = this.$store.getters.user.role;
      if (role == 1) {
        window.location = "/admin";
      } else {
        window.location = "/";
      }
    },
  },
};
</script>
